var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 427,
    viewBox: "0 0 515 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.649 123.888C255.86 123.888 283.593 96.1549 283.593 61.9441C283.593 27.7333 255.86 0 221.649 0C187.438 0 159.705 27.7333 159.705 61.9441C159.705 96.1549 187.438 123.888 221.649 123.888Z",
    fill: "#D7D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.927 181.918H215.328C210.31 181.918 206.242 177.849 206.242 172.832V70.2071C206.242 65.1888 210.31 61.1211 215.328 61.1211H345.927C350.945 61.1211 355.013 65.1893 355.013 70.2071V172.832C355.013 177.849 350.944 181.918 345.927 181.918Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.238 82.2734C246.075 82.2734 228.107 100.24 228.107 122.404C228.107 134.99 233.903 146.221 242.969 153.578L268.238 122.404V82.2734Z",
    fill: "#59DEEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.369 122.404C308.369 100.241 290.402 82.2734 268.238 82.2734V122.404L276.809 161.614C294.854 157.688 308.369 141.626 308.369 122.404Z",
    fill: "#24605A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.969 153.578C249.868 159.177 258.66 162.535 268.238 162.535C271.18 162.535 274.047 162.215 276.809 161.614L268.238 122.404L242.969 153.578Z",
    fill: "#FFD9A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.238 82.2734V122.404L300.586 146.154",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.19 92.3828H291.973V98.3079H322.19V92.3828Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.065 132.869H301.848V138.794H332.065V132.869Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 105.022H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 108.973H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 112.922H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 146.154H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 150.104H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M315.277 154.055H334.632",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.792 254.304H171.314V259.496H197.792V254.304Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.419 248.1H175.688C173.272 248.1 171.314 246.142 171.314 243.726V232.847C171.314 230.431 173.273 228.474 175.688 228.474H193.419C195.834 228.474 197.792 230.432 197.792 232.847V243.726C197.792 246.142 195.834 248.1 193.419 248.1Z",
    fill: "#24605A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.316 264.653H188.276",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.316 268.114H188.276",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.316 271.575H188.276",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.408 293.787H17.9266C12.9426 293.787 8.90234 289.747 8.90234 284.763V172.183C8.90234 167.198 12.9426 163.158 17.9266 163.158H209.408C214.392 163.158 218.433 167.198 218.433 172.183V284.763C218.433 289.747 214.392 293.787 209.408 293.787Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.549 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.082 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6133 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1445 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6758 163.158V293.787",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90234 244.85L31.0498 230.208C32.6339 229.161 34.6965 229.189 36.2522 230.278L52.6122 241.734C54.9454 243.368 58.187 242.524 59.4272 239.96L77.5449 202.492C79.3665 198.725 84.8569 199.123 86.1172 203.113L103.478 258.083C104.751 262.114 110.318 262.464 112.087 258.625L128.184 223.684C129.676 220.444 134.121 220.043 136.169 222.963L156.018 251.262",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 219.981C72.4125 221.915 70.8447 223.482 68.9113 223.482C66.9779 223.482 65.4102 221.914 65.4102 219.981C65.4102 218.047 66.9779 216.479 68.9113 216.479C70.8447 216.479 72.4125 218.047 72.4125 219.981Z",
    fill: "#59DEEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0107 214.913L58.8321 209.612H21.6376C19.5898 209.612 17.9297 207.952 17.9297 205.904V189.962C17.9297 187.914 19.5898 186.254 21.6376 186.254H62.9431C64.9909 186.254 66.651 187.914 66.651 189.962V209.612V213.837C66.6515 215.217 64.9756 215.9 64.0107 214.913Z",
    fill: "#FFD9A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 278.807H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 261.743H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 244.679H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 227.615H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 210.551H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 193.487H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 176.423H12.8547",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.158 245.189C124.689 245.189 127.551 242.327 127.551 238.797C127.551 235.266 124.689 232.404 121.158 232.404C117.628 232.404 114.766 235.266 114.766 238.797C114.766 242.327 117.628 245.189 121.158 245.189Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.434 172.556H156.02",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M268.403 340.728H218.602C212.276 340.728 207.148 335.6 207.148 329.274V291.565C207.148 285.239 212.276 280.111 218.602 280.111H268.403C274.728 280.111 279.856 285.239 279.856 291.565V329.274C279.856 335.6 274.729 340.728 268.403 340.728Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M225.534 291.146C225.534 290.013 224.615 289.094 223.482 289.094C222.349 289.094 221.43 290.013 221.43 291.146C221.43 292.279 222.349 293.198 223.482 293.198C224.615 293.197 225.534 292.279 225.534 291.146Z",
    fill: "#FFA33E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M238.721 291.146C238.721 290.013 237.802 289.094 236.669 289.094C235.536 289.094 234.617 290.013 234.617 291.146C234.617 292.279 235.536 293.198 236.669 293.198C237.803 293.197 238.721 292.279 238.721 291.146Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M251.905 291.146C251.905 290.013 250.986 289.094 249.853 289.094C248.719 289.094 247.801 290.013 247.801 291.146C247.801 292.279 248.72 293.198 249.853 293.198C250.986 293.198 251.905 292.279 251.905 291.146Z",
    fill: "#59DEEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M265.089 291.146C265.089 290.013 264.17 289.094 263.036 289.094C261.903 289.094 260.984 290.013 260.984 291.146C260.984 292.279 261.903 293.198 263.036 293.198C264.17 293.197 265.089 292.279 265.089 291.146Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M225.534 303.758C225.534 302.625 224.615 301.706 223.482 301.706C222.349 301.706 221.43 302.624 221.43 303.758C221.43 304.891 222.349 305.81 223.482 305.81C224.615 305.81 225.534 304.891 225.534 303.758Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M238.721 303.758C238.721 302.625 237.802 301.706 236.669 301.706C235.536 301.706 234.617 302.624 234.617 303.758C234.617 304.891 235.536 305.81 236.669 305.81C237.803 305.81 238.721 304.891 238.721 303.758Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M251.905 303.758C251.905 302.625 250.986 301.706 249.853 301.706C248.719 301.706 247.801 302.624 247.801 303.758C247.801 304.891 248.72 305.81 249.853 305.81C250.986 305.81 251.905 304.891 251.905 303.758Z",
    fill: "#24605A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M265.089 303.758C265.089 302.625 264.17 301.706 263.036 301.706C261.903 301.706 260.984 302.624 260.984 303.758C260.984 304.891 261.903 305.81 263.036 305.81C264.17 305.81 265.089 304.891 265.089 303.758Z",
    fill: "#FFA33E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M225.534 316.37C225.534 315.237 224.615 314.318 223.482 314.318C222.349 314.318 221.43 315.237 221.43 316.37C221.43 317.504 222.349 318.422 223.482 318.422C224.615 318.422 225.534 317.504 225.534 316.37Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M238.721 316.37C238.721 315.237 237.802 314.318 236.669 314.318C235.536 314.318 234.617 315.237 234.617 316.37C234.617 317.504 235.536 318.422 236.669 318.422C237.803 318.422 238.721 317.504 238.721 316.37Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M251.905 316.37C251.905 315.237 250.986 314.318 249.853 314.318C248.719 314.318 247.801 315.237 247.801 316.37C247.801 317.504 248.72 318.422 249.853 318.422C250.986 318.422 251.905 317.504 251.905 316.37Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M265.089 316.37C265.089 315.237 264.17 314.318 263.036 314.318C261.903 314.318 260.984 315.237 260.984 316.37C260.984 317.504 261.903 318.422 263.036 318.422C264.17 318.422 265.089 317.504 265.089 316.37Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M225.534 328.984C225.534 327.851 224.615 326.932 223.482 326.932C222.349 326.932 221.43 327.85 221.43 328.984C221.43 330.117 222.349 331.036 223.482 331.036C224.615 331.035 225.534 330.117 225.534 328.984Z",
    fill: "#59DEEB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.721 328.984C238.721 327.851 237.802 326.932 236.669 326.932C235.536 326.932 234.617 327.85 234.617 328.984C234.617 330.117 235.536 331.036 236.669 331.036C237.803 331.035 238.721 330.117 238.721 328.984Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M249.853 331.036C250.986 331.036 251.905 330.117 251.905 328.984C251.905 327.85 250.986 326.932 249.853 326.932C248.72 326.932 247.801 327.85 247.801 328.984C247.801 330.117 248.72 331.036 249.853 331.036Z",
    fill: "#FFA33E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M263.038 331.036C264.172 331.036 265.09 330.117 265.09 328.984C265.09 327.85 264.172 326.932 263.038 326.932C261.905 326.932 260.986 327.85 260.986 328.984C260.986 330.117 261.905 331.036 263.038 331.036Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M456.387 179.186H414.996V198.823H456.387V179.186Z",
    fill: "#59DEEB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M414.995 257.249H379.43V276.886H414.995V257.249Z",
    fill: "#59DEEB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M491.952 276.887H456.387V296.524H491.952V276.887Z",
    fill: "#FFA33E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M456.387 218.459H414.996V257.733H456.387V218.459Z",
    fill: "#FFD9A6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M484.357 317.866H387.024C382.83 317.866 379.43 314.466 379.43 310.271V158.631C379.43 154.437 382.83 151.036 387.024 151.036H484.357C488.551 151.036 491.951 154.437 491.951 158.631V310.271C491.951 314.466 488.551 317.866 484.357 317.866Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M414.998 151.036V317.866",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M456.391 151.036V317.866",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 179.186H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 198.822H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 218.459H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 238.096H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 257.732H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 277.37H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M379.43 297.007H491.951",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M496.33 289.571C506.643 287.136 513.028 276.802 510.593 266.49C508.158 256.178 497.825 249.792 487.512 252.227C477.2 254.662 470.814 264.996 473.249 275.308C475.684 285.62 486.018 292.006 496.33 289.571Z",
    fill: "#24605A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M483.896 273.257L487.682 276.823C488.572 277.661 489.998 277.518 490.704 276.52L500.003 263.357",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M491.953 286.862C500.736 286.862 507.856 279.742 507.856 270.958C507.856 262.175 500.736 255.055 491.953 255.055C483.169 255.055 476.049 262.175 476.049 270.958C476.049 279.742 483.169 286.862 491.953 286.862Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M482.147 373.526L476.043 367.422L469.939 373.526L476.043 379.63L482.147 373.526Z",
    fill: "#24605A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M175.132 124.851L169.027 118.747L162.923 124.851L169.027 130.956L175.132 124.851Z",
    fill: "#59DEEB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M459.848 352.566C461.766 350.649 461.766 347.539 459.848 345.621C457.93 343.703 454.82 343.703 452.902 345.621C450.985 347.539 450.984 350.649 452.902 352.566C454.82 354.484 457.93 354.484 459.848 352.566Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M304.205 193.963V274.941",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M344.692 234.452H263.715",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M332.835 205.822L275.574 263.082",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M332.835 263.082L275.574 205.822",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M451.473 104.161V89.4523H442.953C442.288 86.9265 441.284 84.5395 439.999 82.336L446.028 76.3075L435.628 65.9074L429.599 71.9365C427.396 70.6514 425.009 69.6476 422.483 68.9823V60.4629H407.775V68.9823C405.249 69.6481 402.862 70.652 400.658 71.9365L394.63 65.9074L384.23 76.3075L390.259 82.336C388.974 84.5395 387.97 86.9265 387.305 89.4523H378.785V104.161H387.305C387.97 106.686 388.974 109.073 390.259 111.277L384.23 117.305L394.63 127.705L400.658 121.677C402.862 122.962 405.249 123.965 407.775 124.632V133.151H422.483V124.632C425.008 123.966 427.395 122.962 429.599 121.677L435.628 127.705L446.028 117.305L439.999 111.277C441.284 109.073 442.288 106.686 442.953 104.161H451.473ZM415.129 112.153C406.653 112.153 399.782 105.282 399.782 96.8064C399.782 88.3308 406.653 81.4598 415.129 81.4598C423.604 81.4598 430.475 88.3308 430.475 96.8064C430.475 105.282 423.604 112.153 415.129 112.153Z",
    stroke: "#24605A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M219.245 415.21L209.619 384.289L274.967 370.592L304.32 308.881C308.691 299.695 316.617 292.694 326.268 289.487L336.769 285.997C335.484 292.33 337.118 298.162 346.663 299.336C365.091 301.607 377.417 288.37 381.297 283.474L405.764 296.083C416.164 301.445 422.188 312.665 420.908 324.294L415.396 425.318H301.791L302.995 408.544L302.55 409.49L219.245 415.21Z",
    fill: "#FFA33E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M190.512 425.318H302.971V413.875H190.512V425.318Z",
    fill: "#24605A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4573 425.318H224.193L193.843 331.482H66.1074L96.4573 425.318Z",
    fill: "#24605A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M223.475 423.102L193.842 331.482",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M141.796 389.245C146.255 387.872 148.52 382.377 146.855 376.972C145.19 371.568 140.226 368.3 135.767 369.673C131.308 371.047 129.043 376.542 130.708 381.946C132.373 387.351 137.337 390.619 141.796 389.245Z",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M301.278 411.731C294.478 418.558 283.781 421.202 274.583 418.329L263.374 418.14L255.37 422.538C253.278 423.822 250.748 424.182 248.381 423.531L243.505 422.191L232.158 415.561L264.854 397.332L297.946 395.297L301.278 411.731Z",
    fill: "#A07252"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M243.504 422.191L259.266 412.219L266.717 411.154",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M238.342 419.598L254.104 409.627L261.064 407.56",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M235.066 417.174L250.828 407.202L257.336 404.163",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M415.394 335.751L378.765 413.876L295.46 419.597L287.279 393.321L351.182 374.977L377.594 325.416L415.394 335.751Z",
    fill: "#FFA33E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M414.796 337.028L387.278 395.72C382.758 405.36 373.496 411.907 362.899 412.952L295.461 419.597",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M377.594 325.416L351.182 374.977L287.279 393.321",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M328.843 304.348L313.71 340.574C311.479 345.913 310.687 351.742 311.41 357.482L314.754 384.012",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M285.683 368.71L260.922 373.535",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M398.75 270.914C402.302 268.323 405.68 265.329 407.85 261.505C410.021 257.681 410.842 252.898 409.17 248.832C407.628 245.08 404.139 242.202 403.371 238.219C402.477 233.584 405.476 228.358 403.079 224.291C400.535 219.975 393.959 220.385 390.193 217.081C386.911 214.203 386.001 208.711 381.889 207.249C378.029 205.877 373.981 209.052 369.887 208.901C363.966 208.682 359.482 201.674 353.636 202.632C348.004 203.554 345.716 211.211 340.22 212.748C337.376 213.544 333.976 212.577 331.633 214.374C328.765 216.573 329.628 221.075 328.293 224.433C326.226 229.629 318.837 232.068 318.577 237.653C318.397 241.51 321.938 244.774 321.86 248.634C321.817 250.786 320.646 252.739 320.135 254.829C318.707 260.655 322.528 266.472 326.877 270.603C334.12 277.484 343.475 282.024 353.295 283.758C363.684 285.592 372.897 283.545 382.57 279.766C388.311 277.524 393.768 274.546 398.75 270.914Z",
    fill: "#1F245C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M336.769 285.997L347.892 282.3L351.154 269.882L357.331 246.366H373.386V278.238V279.397L381.297 283.474C377.417 288.371 365.09 301.608 346.663 299.337C337.118 298.163 335.484 292.331 336.769 285.997Z",
    fill: "#A07252"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.283 254.512C335.335 257.048 335.885 259.553 336.908 261.879L337.906 264.154L340.934 271.058C342.694 275.069 347.172 277.134 351.365 275.862L359.002 273.543C364.904 271.752 369.711 267.443 372.14 261.776L373.722 258.086L376.512 251.567L377.178 241.06L377.36 238.207C377.962 228.668 371.605 220.075 362.304 217.86L360.025 217.321C353.557 215.783 346.752 217.618 341.94 222.199H341.937C338.203 225.758 336.019 230.637 335.853 235.793L335.287 253.469C335.275 253.818 335.275 254.167 335.283 254.512Z",
    fill: "#A07252"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M368.041 251.178C368.465 256.569 376.422 260.341 381.813 259.917C387.204 259.492 391.231 254.777 390.807 249.386C390.383 243.995 385.668 239.968 380.277 240.393C374.885 240.817 367.617 245.787 368.041 251.178Z",
    fill: "#A07252"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M369.1 266.784C369.1 266.784 366.642 271.224 359.004 273.542L351.365 275.86",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M352.527 250.412C352.527 251.052 353.047 251.572 353.688 251.572C354.329 251.572 354.848 251.052 354.848 250.412C354.848 249.771 354.329 249.251 353.688 249.251C353.047 249.251 352.527 249.771 352.527 250.412Z",
    fill: "#1F245C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M336.795 249.995C336.795 250.635 337.315 251.155 337.955 251.155C338.596 251.155 339.116 250.635 339.116 249.995C339.116 249.354 338.596 248.834 337.955 248.834C337.315 248.834 336.795 249.354 336.795 249.995Z",
    fill: "#1F245C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M360.963 263.803C364.011 263.803 366.482 261.331 366.482 258.283C366.482 255.235 364.011 252.764 360.963 252.764C357.915 252.764 355.443 255.235 355.443 258.283C355.443 261.331 357.915 263.803 360.963 263.803Z",
    fill: "#7A563D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M335.281 254.512C335.333 257.048 335.884 259.553 336.906 261.879L337.905 264.154C339.097 263.144 339.851 261.633 339.851 259.949C339.851 257.222 337.877 254.959 335.281 254.512Z",
    fill: "#7A563D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M342.036 256.786L344.499 254.581L345.754 250.636C345.869 250.276 346.389 250.308 346.458 250.681L347.663 257.201C347.74 257.614 347.447 258.006 347.029 258.05L342.805 258.494C341.86 258.594 341.335 257.428 342.036 256.786Z",
    fill: "#7A563D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M356.69 257.172C356.69 257.172 353.545 264.493 345.275 262.324",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M378.787 259.591C378.787 258.255 379.87 257.172 381.206 257.172C382.541 257.172 383.624 258.255 383.624 259.591C383.624 260.926 382.541 262.009 381.206 262.009C379.87 262.01 378.787 260.927 378.787 259.591Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M359.081 243.491C356.367 242.416 353.385 242.022 350.484 242.356",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M341.624 242.39C339.234 242.512 336.869 243.096 334.697 244.101",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M331.905 229.082C334.156 231.047 337.151 232.139 340.139 232.085C343.127 232.031 346.113 230.99 348.292 228.944C349.426 231.127 351.412 232.853 353.732 233.671C356.051 234.49 358.669 234.548 360.922 233.56C361.5 237.245 363.351 240.762 366.232 243.133C369.113 245.503 373.032 246.645 376.697 245.949C380.361 245.253 383.664 242.645 384.968 239.15C386.535 234.952 387.102 230.118 384.877 226.23C382.652 222.341 378.356 219.722 373.881 219.524C373.204 216.876 370.627 214.815 368.224 213.513C365.822 212.21 363.087 211.656 360.375 211.318C358.115 211.037 355.816 210.895 353.564 211.239C351.313 211.582 349.096 212.439 347.401 213.96C343.061 213.961 338.38 215.429 335.243 218.427C332.103 221.425 328.636 226.228 331.905 229.082Z",
    fill: "#1F245C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 425.319H483.896",
    stroke: "#1F245C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M130.739 135.832H68.7288C66.8962 135.832 65.4102 137.318 65.4102 139.151C65.4102 140.984 66.8962 142.469 68.7288 142.469H130.739C132.571 142.469 134.058 140.984 134.058 139.151C134.058 137.318 132.571 135.832 130.739 135.832Z",
    fill: "#FFD9A6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M483.896 391.977H441.758C439.925 391.977 438.439 393.462 438.439 395.295C438.439 397.128 439.925 398.614 441.758 398.614H483.896C485.729 398.614 487.215 397.128 487.215 395.295C487.215 393.462 485.729 391.977 483.896 391.977Z",
    fill: "#FFD9A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerimg);
export default __webpack_public_path__ + "static/media/bannerimg.64bb3305fda5705366642b258309a385.svg";
export { ForwardRef as ReactComponent };